// extracted by mini-css-extract-plugin
export var addButton = "_om-0";
export var border = "_om-8";
export var check = "_om-h";
export var danger = "_om-6";
export var dropdownContainer = "_om-1";
export var editModalBody = "_om-j";
export var footerContainer = "_om-i";
export var fullWidth = "_om-a";
export var hide = "_om-9";
export var icon = "_om-3";
export var input = "_om-7";
export var inputFlex = "_om-b";
export var inputWrapper = "_om-c";
export var manualFocus = "_om-5";
export var optionButton = "_om-4";
export var pillWrapper = "_om-e";
export var pointer = "_om-2";
export var showOverflow = "_om-f";
export var tagsFlex = "_om-d";
export var xButton = "_om-g";